// Ported from horizontal-actions-dashboard/frontend/src/components/PriorityBadge.tsx,
// translated from CSS custom properties to MUI Chip styling.

import { Chip } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import type { Priority } from '../../api/horizontalActionsTypes';

const PRIORITY_STYLES: Record<Priority, { bg: string; fg: string; label: string }> = {
  High: { bg: '#fdecea', fg: '#c0392b', label: 'High priority' },
  Medium: { bg: '#fff3e0', fg: '#e65100', label: 'Medium priority' },
  Low: { bg: '#e8f5e9', fg: '#1e7e34', label: 'Low priority' },
  Unknown: { bg: '#f1f1f1', fg: '#616161', label: 'Unknown priority' },
};

export function TerminalsPriorityBadge({ priority }: { priority: Priority }) {
  const style = PRIORITY_STYLES[priority] ?? PRIORITY_STYLES.Unknown;
  return (
    <Chip
      size="small"
      label={priority}
      title={style.label}
      sx={{ backgroundColor: style.bg, color: style.fg, fontWeight: 600 }}
    />
  );
}

export function TerminalsOpenHighPriorityFlag() {
  return (
    <Chip
      size="small"
      icon={<WarningAmberIcon sx={{ fontSize: 16, color: '#c0392b !important' }} />}
      label="High priority — open"
      sx={{ backgroundColor: '#fdecea', color: '#c0392b', fontWeight: 600 }}
    />
  );
}
